import Vue from 'vue';
import api from '@ibkr/clientportal.common/src/api/index'
import * as types from '../../mutation-types'
import { Settings } from '@ibkr/clientportal.common/src/js/settings.js'

let mdTimeout;
let md = {};
let MD_TIMEOUT_THRESHOLD = 200;
//expose over window so can play with
window.MD_TIMEOUT_THRESHOLD = MD_TIMEOUT_THRESHOLD;
//notifications will appear for orders whose status changes to any one in the list
const statusNotification = ['Cancelled', 'Filled'];


const mutations = {

    [types.SET_ALLOW_FEATURES](state, data) {
        state.allowFeatures = data || {};
    },

    [types.SET_ISERVER_INFO](state, data) {
        state.iserverInfo = data || {};
    },

    [types.SET_ISERVER_ACCOUNT_PROPS](state, data) {
        state.acctProps = data || {};
    },

    [types.SET_CHART_PERIODS](state, data) {
        state.chartPeriods = data || {};
    },

    [types.SET_LINKS](state, data) {
        state.links = data || {};
    },

    [types.SET_UPNL](state, data) {
        state.upnl = data || {};
    },

    [types.SET_ISERVER_ACCOUNTS](state, data) {
        state.accounts = data;
    },

    [types.SET_ISERVER_GROUPS](state, data) {
        state.groups = data || [];
    },

    [types.SET_ISERVER_PROFILES](state, data) {
        state.profiles = data || [];
    },

    [types.SET_ISERVER_SSODH](state, ssoDH) {
        state.ssoDH = ssoDH;
    },

    [types.SET_COMPETE](state, compete) {
        state.compete = compete;
    },

    [types.SET_AUTH_STATUS](state, data) {
        if (!data) return;
        /**
         * if the status object doesn't contain backendDown flag, set backendDown flag to false
         * This case is required to handle the scenario  when backend was down
         * (which sets backednDown flag to true) and user receives new status from backend
         * after backend is up again
         */
        if (!data.backendDown) {
            Vue.set(state.status, 'backendDown', false);
        }
        if (data.competing) {
            state.loginStartTime = undefined;
        }
        Object.keys(data).forEach(key => {
            if (data[key] === undefined) {
                return;
            }
            if (state.status[key] != data[key]) {
                Vue.set(state.status, key, data[key]);
                console.debug('status changed', key, data[key]);
            }
        });
    },

    [types.SET_ORDERS](state, data) {
        if (!data) {
            return;
        }
        for (let i = 0; i < data.length; i++) {
            const index = state.orders.findIndex(o => o.orderId == data[i].orderId);
            const upd = data[i];
            if (!upd) {
                continue;
            }
            if (index != -1) {
                const obj = state.orders[index];
                const res = { ...obj, ...upd };
                Vue.set(state.orders, index, res);
                if (upd.status === 'Filled' && obj.status !== 'Filled') {
                    // order executed
                    setNotifications(state, [ { id: 'ORDER_EXECUTED', payload: res } ]);
                }
            } else {
                state.orders.push(data[i]);
            }
        }
    },

    [types.SET_BULLETINS](state, bulletins) {
        if (!bulletins) {
            return;
        }
        if (Array.isArray(bulletins)) {
            // polling provides bulletins as an array
            state.bulletins = bulletins;
        } else {
            // websockets provide single bulletin at a time which is an object
            state.bulletins.push(bulletins);
        }
    },

    [types.MARK_BULLETINS_AS_READ](state, ids) {
        if (!ids) {
            return;
        }
        state.readBulletins = state.readBulletins.concat(ids.filter(id => {
            return state.readBulletins.indexOf(id) === -1;
        }));
        // persist on local storage
        Settings.store('read.bulletins', {
            timestamp: +$date.local(),
            value: state.readBulletins
        });
    },

    [types.SET_MASTER_ID](state, id) {
        state.masterId = id;
    },

    [types.SET_SELECTED_ACCOUNT](state, acct) {
        state.selectedAccount = acct;
    },

    [types.SET_ACCOUNT_ALIASES](state, val) {
        state.aliases = val;
    },

    [types.SET_MARKET_DATA](state, { conid, data }) {
        if (!data) {
            return;
        }
        const curr = md[conid] || {};
        md[conid] = { ...curr, ...data };
        if (!mdTimeout) {
            mdTimeout = setTimeout(() => {
                state.marketData = JSON.parse(JSON.stringify(md));
                mdTimeout = undefined;
            }, MD_TIMEOUT_THRESHOLD);
        }
    },

    /**
     * Resets market data, pnl and orders back to original state as defined in state.js
     */
    [types.CLEAR_ISERVER_DATA](state, {}) {
        if (mdTimeout) {
            clearTimeout(mdTimeout);
            mdTimeout = undefined;
        }
        md = {};
        state.marketData = {};
        state.orders = [];
        state.trades = undefined;
        state.upnl = {};
    },

    [types.SET_BRIEFING_ARTICLE](state, val) {
        state.briefingArticle = val;
    },

    [types.SET_NOTIFICATIONS](state, notifications) {
        setNotifications(state, notifications);
    },

    [types.CURRENCY_PAIRS](state, currencyPairs) {
        if (Object.keys(currencyPairs).length) {
            let currencyKeys = Object.keys(currencyPairs);
            currencyKeys.forEach( key => {
                Vue.set(state.currencyPairs, key, currencyPairs[key])
            });
        }
    },

    [types.SET_CONTRACT_INFO](state, contractInfo) {
        if (contractInfo) {
            Vue.set(state.contractInfo, contractInfo.con_id, contractInfo);
        }
    },

    [types.SET_TRADES](state, trades) {
        if (state.trades) {
            for (let i = 0; i < trades.length; i++) {
                const trade = trades[i];
                /*
                 * When force fetch is performed or when commission update is received, backend might send
                 * trades data which UI already has.
                 * In such cases, to avoid duplicate trades, we need to check if a trade already exists
                 * in the list in UI. If it does, we merge it. If it doesnt, we add the trade to the list as is.
                 */
                const index = state.trades.findIndex(t => t.execution_id == trade.execution_id);
                if (index >= 0) {
                    // merge the new trade data into previous trade object
                    Vue.set(state.trades, index, { ...state.trades[index], ...trade });
                } else {
                    state.trades.push(trade)
                }
            }
        } else {
            state.trades = trades;
        }
    },
    [types.CCY_CHART_PAIR](state, data) {
        Vue.set(state, 'ccyChartPair', data);
    },
    [types.SET_WATCHLISTMAP](state, {id, watchlistConids}) {
        Vue.set(state.watchlistMap, id, watchlistConids);
    },
    [types.SET_ISERVER_LOGGING_IN_STATUS](state, val) {
        state.loggingIn = val;
    },
    [types.SET_AVAILABLE_ALERTS] (state, val) {
        state.availableAlerts = val;
    },
    [types.SET_PRICE_ALERTS] (state, data) {
        state.priceAlertsData = data;
    },
    [types.SET_MTA_ALERTS] (state, data) {
        state.mtaAlerts = data;
    },
    [types.SET_PRICE_ALERTS_DELIVERY_OPTIONS] (state, data) {
        if (data.priceAlertsEmail !== undefined) {
            state.priceAlertsEmail = data.priceAlertsEmail;
        }
        if (data.priceAlertsSwitch !== undefined) {
            state.priceAlertsSwitch = data.priceAlertsSwitch;
        }
    },
    [types.SET_USER_TIMEZONE] (state, data) {
        state.userTimeZone = data;
    },
    [types.SET_ISERVER_LOGIN_INFO] (state, data) {
        state.loginInfo = data;
    },

    SET_USER_WLS(state, wl) {
        state.watchlists = wl;
    },

    SET_SYSTEM_WLS(state, wl) {
        state.exploreWls = wl;
    },

    SET_WL_INSTR(state, { id, instr }) {
        let wl = state.exploreWls.find(wl => wl.id == id);
        if (!wl) {
            wl = state.watchlists.find(wl => wl.id == id);
        }
        if (!wl) {
            return;
        }
        Vue.set(wl, 'instruments', instr);
    },

    SAVE_WATCHLIST(state, wl) {
        let idx = -1;
        for (let i = 0; i < state.watchlists.length; i++) {
            if (state.watchlists[i].id == wl.id) {
                idx = i;
                break;
            }
        }
        if (idx >= 0) {
            Vue.set(state.watchlists[idx], 'id', wl.id);
            Vue.set(state.watchlists[idx], 'hash', wl.hash);
            Vue.set(state.watchlists[idx], 'name', wl.name);
            if (wl.rows) {
                Vue.set(state.watchlists[idx], 'instruments', wl.rows);
            }
        } else {
            state.watchlists.unshift(wl);
        }
    },

    SET_REGSNAPSHOT(state, data) {
        if (!data || !data.conidEx) {
            return;
        }
        Vue.set(state.regSnapshots, data.conidEx, data);
    },

    CLEAR_REGSNAPSHOTS(state) {
        state.regSnapshots = {};
    },

    ISERVER_LOGIN_START_TIME(state) {
        if (!state.loginStartTime) {
            state.loginStartTime = $date.now();
        }
    }
}

function setNotifications(state, notifications) {
    if (!notifications) {
        return;
    }
    if (Array.isArray(notifications)) {
        state.notifications = notifications;
    }
}

export default mutations;
